/**
 * Coarse wall-clock tick for freshness re-evaluation (FR-A8 · Phase 9c).
 *
 * Meta identity alone does not advance when Query structural-shares equal
 * payloads; the 36h / membership / frozen axes still need a periodic re-run
 * against `new Date()`. Default 60s matches meta `staleTime`.
 */
import { useEffect, useState } from 'react';

/** How often shell chrome re-runs evaluateStaleness against wall clock. */
export const STALE_REEVAL_MS = 60_000;

/**
 * Returns a wall-clock timestamp (ms) that re-samples every `intervalMs`.
 *
 * Deliberately the TIMESTAMP and not a bare counter: subscribers pass it
 * straight into the freshness computation, so it is a real data dependency of
 * the memo rather than a dependency-array token that has to be `void`-ed to
 * look used. The value only advances on the interval, so it stays a stable
 * memo key between ticks.
 */
export function useNowTick(intervalMs: number = STALE_REEVAL_MS): number {
  const [nowMs, setNowMs] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => {
      setNowMs(Date.now());
    }, intervalMs);
    return () => {
      window.clearInterval(id);
    };
  }, [intervalMs]);
  return nowMs;
}
